export default __webpack_public_path__ + "static/media/f_fancybox.6e116c2c.svg";